import React, { Component } from "react";
import { VictoryPie } from "victory";
import Dimensions from "react-dimensions";
import isEmpty from "lodash/isEmpty";
import { graphColors, statsToVictoryFormat } from "./utils";
import KnownAgentFriendlyNames from "../../../lib/known_agent_friendly";

class AppGraph extends Component {
  state = {
    currentLabel: "",
    currentPercent: "",
  };

  componentDidMount() {
    this.props.fetchStats(
      {
        isUnique: true,
        [this.props.uuidType]: this.props.uuid,
        timeRange: "allTime",
        bucketTerms: "download.metadata.app",
      },
      this.props.user,
      this.statsRequestID()
    );
  }

  statsRequestID = () => {
    return this.props.uuid + "app-graph";
  };

  render() {
    var innerRadius = Math.min(this.props.containerHeight, this.props.containerWidth / 2) / 2 - 20;
    var outerRadius = Math.min(this.props.containerHeight, this.props.containerWidth / 2) / 2;
    var data = this.getData();
    if (isEmpty(data)) {
      return null;
    }
    return (
      <div className="stats-widget-app-graph">
        <div className="stats-widget-app-graph__list">
          <ol>
            {data.map((row, index) => {
              return (
                <li key={index}>
                  <span className="app-list-label">{index + 1}.</span>
                  {KnownAgentFriendlyNames.get("app", row.x)}
                </li>
              );
            })}
          </ol>
        </div>
        <div className="stats-widget-app-graph__pie">
          <div
            className="stats-widget-app-graph__pielabel"
            style={{
              width: innerRadius * 2,
              height: innerRadius * 2,
              marginLeft: -innerRadius,
              marginTop: -innerRadius,
              borderRadius: innerRadius,
            }}>
            <div
              style={{ borderRadius: innerRadius }}
              className="stats-widget-app-graph__pielabel__inner redcircle-label">
              {this.state.currentLabel}
              <br />
              {this.state.currentPercent}
            </div>
          </div>
          <VictoryPie
            data={this.getDataWithOther()}
            radius={outerRadius}
            innerRadius={innerRadius}
            height={this.props.containerHeight}
            width={this.props.containerWidth / 2}
            standalone={true}
            padding={0}
            labels={() => ""}
            colorScale={graphColors}
            events={[
              {
                target: "data",
                eventHandlers: {
                  onMouseOver: () => {
                    return [
                      {
                        target: "data",
                        mutation: props => this.setLabel(props.datum),
                      },
                    ];
                  },
                  onMouseOut: () => {
                    return [
                      {
                        target: "data",
                        mutation: () => this.clearLabel(),
                      },
                    ];
                  },
                },
              },
            ]}
          />
        </div>
      </div>
    );
  }

  getData = () => {
    return statsToVictoryFormat(this.props.stats, this.statsRequestID(), {
      limit: 5,
    }).sort((a, b) => b.y - a.y);
  };

  getDataWithOther = () => {
    return statsToVictoryFormat(this.props.stats, this.statsRequestID(), {
      limit: 5,
      withOther: true,
    });
  };

  setLabel = datum => {
    var total = datum.total;
    this.setState({
      currentLabel: datum.x === "Other" ? datum.x : KnownAgentFriendlyNames.get("app", datum.x),
      currentPercent: Math.round((datum.y / total) * 100) + "%",
    });
    return null;
  };

  clearLabel = () => {
    this.setState({
      currentLabel: "",
      currentPercent: "",
    });
  };
}

export default Dimensions()(AppGraph);
